/**
 * Request Context Plugin for Admin Contextual Panel
 *
 * Handles request pages: /requests/:id
 */

import React from "react";
import { registerContext } from "../contextRegistry";

function RequestContextPanel({ contextProps }) {
  const { id } = contextProps;
  return (
    <div>
      <p className="small text-muted mb-2">Viewing request: {id}</p>
    </div>
  );
}

// Register this context
registerContext({
  name: "request",
  priority: 10,
  patterns: [
    {
      pattern: /\/requests\/([^/?]+)/,
      extract: (match) => ({ id: match[1] }),
    },
  ],
  component: RequestContextPanel,
});

export default RequestContextPanel;
